import z from 'zod'

import type { SortKeyInput } from './sortMillsheetItems'
import { applySortDirection, compareMillsheetItemValueByConfig, normalizeSortKeys } from './sortMillsheetItems'

const millsheetSortConfigSchema = z.object({
  // 「メーカー」「規格」「形状」の並び替え順をカスタマイズ設定できる
  manufacturerName: z.string().array().nullish(),
  steelType: z.string().array().nullish(),
  sectionType: z.string().array().nullish(),
})

type MillsheetSortConfig = z.infer<typeof millsheetSortConfigSchema>

type ExtendedMillsheet = {
  //   - 製造会社名
  // - 規格
  // - 形状
  // - 証明書番号
  // - 工区

  manufacturerName: string
  // steelType: string
  // sectionType: string
  no: string
  constructionArea: string
  [key: string]: unknown
}

export function sortMillsheets<Item extends ExtendedMillsheet>(
  items: Item[],
  sortConfig: MillsheetSortConfig,
  sortKeys: readonly SortKeyInput[],
): Item[] {
  const specs = normalizeSortKeys(sortKeys)
  // 汎用的に使えるようにするため、Record型のItemを、keysでソートする
  return [...items].sort((a, b) => {
    for (const { key: sortKey, direction } of specs) {
      const aValue = a[sortKey] ?? ''
      const bValue = b[sortKey] ?? ''
      if (aValue !== bValue) {
        // 値が等しい（比較結果が 0）ときだけ次のキーへ進む
        const result = compareValues(aValue, bValue, sortConfig, sortKey)
        if (result !== 0) {
          return applySortDirection(result, direction)
        }
      }
    }
    return 0
  })
}

function compareValues(aValue: unknown, bValue: unknown, sortConfig: MillsheetSortConfig, sortKey: string): number {
  if (typeof aValue === 'string' && typeof bValue === 'string') {
    return compareMillsheetItemValueByConfig(aValue, bValue, sortConfig, sortKey)
  }
  if (typeof aValue === 'number' && typeof bValue === 'number') {
    return aValue - bValue
  }
  return 0
}
